import '@wix/design-system/styles.css';
import { WixDesignSystemProvider } from '@wix/design-system';
import { Provider as JotaiProvider } from 'jotai';
import React, { Suspense } from 'react';
import { dataHooks } from '../../utils/datahooks';
import { OnToggleFunctionsContext } from '../../utils/use-on-toggle-functions';
import { UnsavedChangesHandlersContext } from '../../utils/use-unsaved-changes-handlers';
export const RulesPanelUIProvider = _ref => {
  let {
    children,
    store,
    unsavedChangesHandlers,
    onToggleFunctions
  } = _ref;
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(WixDesignSystemProvider, {
    features: {
      newColorsBranding: true
    }
  }, /*#__PURE__*/React.createElement(JotaiProvider, {
    store: store
  }, /*#__PURE__*/React.createElement(UnsavedChangesHandlersContext.Provider, {
    value: unsavedChangesHandlers
  }, /*#__PURE__*/React.createElement(OnToggleFunctionsContext.Provider, {
    value: onToggleFunctions
  }, /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHooks.rulesPanelUiWrapper
  }, children))))));
};
//# sourceMappingURL=rules-panel-ui-provider.js.map